import {
    guideClickOnElement,
    guideWaitForElement,
    clickOnGridRow,
    clickOnTab, guideWaitForElementByXPath, scrollSelectorToBottom, clickOnText
} from "@/components/dashboard/guides/guidNavigation";
import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";

export function brandingGuideSteps(initialMenu) {
    let menu = initialMenu;
    return [
        {
            target: '#dark-navbar',
            header: {
                title: 'Hello There',
            },
            content: "I’ll guide you through obtaining care labels. Let's get started.",
            imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Branding-Tour.png",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    menu = "mobile-"
                } else {
                    menu = ""
                }
            }
        },
        {
            target: () => `#${menu}m-plm`,
            previous: true,
            content: "Click on the PRODUCT LIFECYCLE module.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu = "mobile-"
                    EventBus.$emit('openMainMenu');
                    await guideClickOnElement(`#${menu}m-plm`);
                } else {
                    menu = ""
                    await guideClickOnElement('#m-plm');
                }
                await sleep(500);
            }
        },
        {
            target: () => `#${menu}plm-form-ProductInSeason`,
            previous: true,
            content: "Now, click on the Projects section.",
            beforeNext: async () => {
                if (isBelowBreakpoint("md")) {
                    menu = "mobile-"
                    await guideClickOnElement(`[id='${menu}plm-form-ProductInSeason'] a`)
                } else {
                    menu = ""
                    await guideClickOnElement("[id='plm-form-ProductInSeason'] a")
                }
                await guideWaitForElementByXPath("//*[contains(@class, 'activity-top')]//*[@data-test-path='base-grid']//*[@data-row='0']//*[@data-col='0']")
                await sleep(500);
            }
        },
        {
            targetXPath: "//*[contains(@class, 'activity-top')]//*[@data-test-path='base-grid']//*[@data-row='0']//*[@data-col='0']",
            previous: true,
            content: "Let’s select the project.",
            beforeNext: async () => {
                await clickOnGridRow(0)
                await guideWaitForElement('.activity-top [data-test-path="grid-header-details-Products in Season"]');
                await sleep(500);
            }
        },
        {
            target: '.activity-top [data-test-path="grid-header-details-Products in Season"]',
            previous: true,
            content: "Now, click on the Details button.",
            beforeNext: async () => {
                await guideClickOnElement('.activity-top [data-test-path="grid-header-details-Products in Season"]');
                await guideWaitForElementByXPath("//*[contains(@class, 'activity-top')]//*[normalize-space(text())='Branding Settings']")
                await sleep(500);
            }
        },
        {
            targetXPath: "//*[contains(@class, 'activity-top')]//*[normalize-space(text())='Branding Settings']",
            previous: true,
            content: "Go to the Branding Settings tab.",
            beforeNext: async () => {
                await clickOnTab("Branding Settings")
                await scrollSelectorToBottom("//div[@data-vbox=\"vbox-root\"]//div[contains(@class, 'container-fluid')]", 10000);
                await guideWaitForElementByXPath("//*[contains(@class, 'activity-top')]//a[normalize-space(text())='Wash Care Label']")
                await sleep(500);
            }
        },
        {
            targetXPath: "//*[contains(@class, 'activity-top')]//a[normalize-space(text())='Wash Care Label']",
            previous: true,
            content: "Then go to the Brandings Details section and download the label you are interested in.",
            beforeNext: async () => {
                await clickOnText("Wash Care Label", true, "", "//a")
                await guideWaitForElement('[data-test-path="notifications_bottom"]');
                await sleep(500);
            }
        },
        {
            target: '[data-test-path="notifications_bottom"]',
            content: "Now after generation you can download, check your prepared care labels.",
        },
    ]
}